import { render, staticRenderFns } from "./NewOrderSidebar.vue?vue&type=template&id=cae3b3bc&"
import script from "./NewOrderSidebar.vue?vue&type=script&lang=js&"
export * from "./NewOrderSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports